import { ApiResponse, AuthLinkRequestData, AuthLinkCallbackData, AuthStatusData, ProfileData } from '../../types/api';
import { api } from './client';

// Auth endpoints
export const auth = {
  signup: async (data: {
    email: string;
    password: string;
    name: string;
    company_name: string;
    ready_to_contact: boolean;
  }): Promise<ApiResponse> => {
    const response = await api.post<ApiResponse>('/auth/signup', data);
    return response.data;
  },
  signin: async (data: { email: string; password: string }): Promise<ApiResponse> => {
    const response = await api.post<ApiResponse>('/auth/signin', data);
    return response.data;
  },
  verify: async (code: string): Promise<ApiResponse> => {
    const response = await api.post<ApiResponse>(`/auth/verify?code=${code}`);
    return response.data;
  },
  signout: async (): Promise<ApiResponse> => {
    const response = await api.post<ApiResponse>('/auth/signout');
    return response.data;
  },
  checkStatus: async (): Promise<ApiResponse<AuthStatusData>> => {
    const response = await api.get<ApiResponse<AuthStatusData>>('/auth/status');
    return response.data;
  },
  // Новые методы для авторизации через email link
  requestAuthLink: async (email: string, captchaToken?: string): Promise<ApiResponse<AuthLinkRequestData>> => {
    const response = await api.post<ApiResponse<AuthLinkRequestData>>('/auth/auth-link/request', {
      email,
      captcha_token: captchaToken || '',
    });
    return response.data;
  },
  callbackAuthLink: async (token: string): Promise<ApiResponse<AuthLinkCallbackData>> => {
    const response = await api.get<ApiResponse<AuthLinkCallbackData>>(`/auth/auth-link/callback?token=${token}`);
    return response.data;
  },
  getGoogleAuthURL: async (): Promise<ApiResponse<{ auth_url: string }>> => {
    const response = await api.get<ApiResponse<{ auth_url: string }>>('/auth/google/url');
    return response.data;
  },
  googleCallback: async (code: string, codeVerifier: string): Promise<ApiResponse<AuthLinkCallbackData>> => {
    const response = await api.post<ApiResponse<AuthLinkCallbackData>>('/auth/google/callback', {
      code,
      code_verifier: codeVerifier,
    });
    return response.data;
  },

  // Новые методы для работы с профилем
  getProfile: async (): Promise<ApiResponse<ProfileData>> => {
    const response = await api.get<ApiResponse<ProfileData>>('/profile');
    return response.data;
  },

  updateProfile: async (data: {
    name: string;
    company_name: string;
    ready_to_contact: boolean;
  }): Promise<ApiResponse<ProfileData>> => {
    const response = await api.put<ApiResponse<ProfileData>>('/profile', data);
    return response.data;
  },
};
